import { getWindowLocationOrigin } from '../../../utils/window'
import { generateMetaTags } from '../../../utils/helmet'

const title = 'Prospect - Immersive VR Walkthroughs | View 3D Models in VR'
const description =
  'Prospect by IrisVR is no longer sold. For immersive design review, see Autodesk Workshop XR for AEC teams.'
const url = `${getWindowLocationOrigin()}/prospect`
const image =
  'https://s3.amazonaws.com/iris-opengraph-images/ImgTag_Prospect.jpg'
const imageWidth = 1200
const imageHeight = 697

export default generateMetaTags({
  title,
  description,
  image,
  url,
  imageWidth,
  imageHeight,
})
